// extracted by mini-css-extract-plugin
export default {"root":"BV22op"};